$(document).ready(function(){
  
  $('.marquee-left').marquee({
      direction: 'left',
      duration: 40000,
      delayBeforeStart: 0,
      duplicated: true,
      gap: 0,
      startVisible: true
    });

  $(".banner_slider .banner_list").slick({
    dots: true,
    infinite: true,
    arrows: false,
    speed: 1000,
    slidesToShow: 1,
    adaptiveHeight: true,
  });
  $(".lifestyle-photos").slick({
    dots: false,
    infinite: true,
    arrows: false,
    speed: 1000,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    fade: true,
    adaptiveHeight: true,
    cssEase: 'linear'
  });

  $(".review-carousel").slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1
        }
      }
    ]
  });
  $(".lookbook-section .sliding-block").slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2
        }
      },
      {
        breakpoint: 550,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1
        }
      }
    ]
  });

  function spotlight_slider(){
    $(".spotlight-section .spotlight-grid").slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 3
          }
        },
        {
          breakpoint: 880,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 2
          }
        },
        {
          breakpoint: 550,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 1
          }
        }
      ]
    });
  }
  spotlight_slider();
  document.addEventListener("shopify:section:load", spotlight_slider);


  $(document).on('click', '.accordion details summary', function (e) {

      // If clicked on the link (or anything inside the link),
      // allow the normal link behavior.
      if ($(e.target).closest('a').length) {
          return;
      }

      e.preventDefault();

      const $details = $(this).parent('details');

      if ($details.attr('open')) {
          $details.removeAttr('open');
      } else {
          $('.accordion details').removeAttr('open');
          $details.attr('open', 'open');
      }
  });

});

jQuery(document).ready(function ($) {
    if ($(window).width() <= 550) {
        $('.template-product .product-tab-sec .tabs li.active').removeClass('active');
        $('.template-product .product-tab-sec .tab_content').css('display', 'none');
    }
});
// tabbed content
// http://www.entheosweb.com/tutorials/css/tabs.asp
$(".tab-container .tab_content").hide();
// $(".tab-container .tab_content:first").show();
$('.tab-container').each(function(k,v){
  $(v).find('.tab_content:first').show();
});

/* if in tab mode */
$("ul.tabs li").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var activeTab = $(this).attr("rel");
  $(parent).find("#"+activeTab).fadeIn();

  $(parent).find("ul.tabs li").removeClass("active");
  $(this).addClass("active");

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");

  $('.products-slider-section .product-slider').slick('refresh');
  
});
/* if in drawer mode */
$(".tab_drawer_heading").click(function() {
  var parent = $(this).parents('.tab-container');
  var d_activeTab = $(this).attr("rel");
  var target = $(parent).find("#" + d_activeTab);

  // If clicked tab is already active, close it
  if ($(this).hasClass("d_active") && target.is(":visible")) {
    target.fadeOut();

    $(this).removeClass("d_active");
    $(parent).find("ul.tabs li").removeClass("active");
  } else {
    // Hide all tab content
    $(parent).find(".tab_content").hide();

    // Show clicked tab content
    target.fadeIn();

    // Update active classes
    $(parent).find(".tab_drawer_heading").removeClass("d_active");
    $(this).addClass("d_active");

    $(parent).find("ul.tabs li").removeClass("active");
    $(parent)
      .find("ul.tabs li[rel^='" + d_activeTab + "']")
      .addClass("active");
  }

  $('.products-slider-section .product-slider').slick('refresh');
});

$(document).on('click','.select-label', function () {
    if($(this).parent().hasClass('active')){
      $(this).parent().removeClass('active');
    }else{
      $('.dropdown').removeClass('active');
      $(this).parent().addClass('active');
    }
});
$(document).on('click','.dropdown-list li', function () {
    $(this).parents('.dropdown').find('.select-label_inner').text($(this).text());
    $(this).parents('.dropdown').removeClass('active');
    var variant_id = $(this).data('value');
    $(this).parents('.main_variant_div').parent().find('.product-variant-id').val(variant_id);
});



  // Fancybox open for pdp page
// Fancybox Config
Fancybox.bind('[data-fancybox="gallery"]', {
//
 Thumbs: {
      type: ""
  },
  Image: {
        zoom: true,
        wheel: true, // Enable mouse wheel zoom
        protect: true
    }
});




//
$(function () {
      $('.review-slider-inner').slick({
          autoplay: true,
          autoplaySpeed: 0,
          speed: 5000,
          arrows: false,
          swipe: false,
          slidesToShow: 6,
          cssEase: 'linear',
          pauseOnFocus: false,
          pauseOnHover: false,
          responsive: [
              {
                  breakpoint: 1599,
                  settings: {
                      slidesToShow: 5,
                  }
              },
              {
                  breakpoint: 1399,
                  settings: {
                      slidesToShow: 4,
                  }
              },
              {
                  breakpoint: 1199,
                  settings: {
                      slidesToShow: 2.8,
                  }
              },
              {
                  breakpoint: 767,
                  settings: {
                      slidesToShow: 2,
                  }
              },
              {
                  breakpoint: 575,
                  settings: {
                      slidesToShow: 1.4,
                  }
              }
          ]
      });
  });

  $(function () {

  var $slider = $('.review-video-slider');

  $slider.on('init', function (event, slick) {
      playCenterVideo();
  });

  $slider.slick({
      autoplay: false,
      autoplaySpeed: 0,
      speed: 500,
      arrows: false,
      slidesToShow: 5,
      cssEase: 'linear',
      centerMode: true,
      centerPadding: '80px',
      dots: true,
      infinite: true,
      touchThreshold: 500,
      responsive: [                
          {
              breakpoint: 1399,
              settings: {
                  slidesToShow: 3,
                    centerPadding: '100px',
              }
          },
          {
              breakpoint: 991,
              settings: {
                  slidesToShow: 3,
                  centerPadding: '40px',
              }
          },
          {
              breakpoint: 767,
              settings: {
                  slidesToShow: 3,
                  centerPadding: '30px',
              }
          },
          {
              breakpoint:640,
              settings: {
                  slidesToShow: 1,
                  centerPadding: '30%',
              }
          },
          {
              breakpoint:640,
              settings: {
                  slidesToShow: 1,
                  centerPadding: '24%',
              }
          },
          {
              breakpoint:420,
              settings: {
                  slidesToShow: 1,
                  centerPadding: '18%',
              }
          }
      ]
  });

  function playCenterVideo() {

      $('.review-video-slider video').each(function () {
          this.pause();
          this.currentTime = 0;
      });

      const video = $('.review-video-slider .slick-slide.slick-current video').get(0);

      if (video) {
          video.play().catch(() => {});
      }
  }

  $slider.on('init afterChange', function () {
      setTimeout(function () {
          playCenterVideo();
      }, 50);
  });
});

// ---------------------------------------------------------------
// video tag video plays js
document.addEventListener("click", function (e) {
  const poster = e.target.closest(".deferred-media__poster");

  if (!poster) return;

  const deferredMedia = poster.closest("deferred-media");

  if (!deferredMedia || deferredMedia.classList.contains("loaded")) return;

  deferredMedia.classList.add("loaded");

  const template = deferredMedia.querySelector("template");

  if (!template) return;

  const clone = template.content.cloneNode(true);

  poster.remove();

  deferredMedia.appendChild(clone);

  const video = deferredMedia.querySelector("video");

  if (video) {
    video.play().catch(() => {});
  }
});



// popup

$(document).ready(function() {

  $('.sm_open').on('click', function(){
      var modal = $(this).attr('data-modal');
      var modaloverlaycolor = $(this).attr('data-overlay');
      var modaleffect = $(this).attr('data-effect');
      var modalheader = $(this).attr('data-header');
      var modalheadertype = $(this).attr('data-header-type');
      var modalcontent = $(this).attr('data-content');
      var modaliconside = $(this).attr('data-icons');
      var modalwrappercolor = $(this).attr('data-wrapper-color');
  
      $('#' + modal).addClass(modaloverlaycolor);
      $('#' + modal + ' .sm_content').addClass(modaleffect);
      $('#' + modal + ' .sm_content .sm_header').html(modalheader);
      $('#' + modal + ' .sm_content .sm_header').addClass(modalheadertype);
      $('#' + modal + ' .sm_content .sm_area_all').html(modalcontent);
      $('#' + modal + ' .sm_icon_menu').addClass(modaliconside);
      $('#' + modal + ' .sm_content').addClass(modalwrappercolor);
      $('#' + modal).fadeIn().css("display", "flex");
      setTimeout(function(){
          $('#'+modal + ' .sm_content').addClass('show');
      }, 400);        
  });
  
  $('.sm_close').on('click', function(){
      var $modal = $(this).parents('.slim_modal');
      closeModal($modal);  
  });
  
  $('.slim_modal').on('click', function(e) {
    if (e.target !== this)
      return;
      var $modal = $(this);
      closeModal($modal);
  });
  
  function closeModal($modal) {
      $modal.find('.sm_content').removeClass('show');
      setTimeout(function(){
          $modal.removeClass('red green tan none');
          $modal.find('.sm_content').removeClass('red green tan');
          $modal.find('.sm_icon_menu').removeClass('is_right is_left');
          $modal.find('.sm_header').removeClass('detached');
          $modal.fadeOut();
      }, 400);
  }
});


  

// subscription option price update to add to cart button
function getSelectedPlanPrice() {
  const checkedCheckbox = document.querySelector(
    '.subscription-widget__options .subscription-widget__radio:checked'
  );

  if (!checkedCheckbox) {
    console.log('No purchase option selected');
    return;
  }

  const purchaseOption = checkedCheckbox.dataset.purchaseOption;

  const card = document.querySelector(
    `.subscription-widget__card[data-card="${purchaseOption}"]`
  );

  if (!card) {
    console.log('Card not found for:', purchaseOption);
    return;
  }

  const planPrice = card.dataset.planPrice;

  console.log('Purchase Option:', purchaseOption);
  console.log('Plan Price:', planPrice);

  const atcBtnTxt = document.querySelector(".product__submit__buttons button.product__submit__add .product__price--regular");
  atcBtnTxt.innerHTML = planPrice;

  return planPrice;
}


// Initial load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', getSelectedPlanPrice);
} else {
  getSelectedPlanPrice();
}

document.addEventListener('change', function (event) {
  if (
    event.target.matches(
      '.subscription-widget__options .subscription-widget__radio'
    )
  ) {
    getSelectedPlanPrice();
  }
});




